import { createContext } from 'react';

const targetcontrolcontext = createContext();

export default targetcontrolcontext;